import * as actions from "./actionsType";

const initialData = {
  loaderTrainingEvents: false,
  loaderPersonResponsible: false,
  personResponsible: null,
  trainingEvents: null,
  trainingEventsFalla: null,
  saveLoaderTrainingEvents: false,
  trainingEventsFormError: null,
};

export default function TrainingEventsReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_TRAINING_EVENTS:
      return { ...state, loaderTrainingEvents: action.payload };

    case actions.LOADER_PERSON_RESPONSIBLE:
      return { ...state, loaderPersonResponsible: action.payload };

    case actions.GET_PERSON_RESPONSIBLE:
      return { ...state, personResponsible: action.payload };

    case actions.GET_TRAINING_EVENTS:
      return { ...state, trainingEvents: action.payload };

    case actions.TRAINING_EVENTS_FALLA:
      return { ...state, trainingEventsFalla: action.payload };

    case actions.SAVE_LOADER_TRAINING_EVENTS:
      return { ...state, saveLoaderTrainingEvents: action.payload };

    case actions.FORM_TRAINING_EVENTS_FAIL:
      return { ...state, trainingEventsFormError: action.payload };

    default:
      return state;
  }
}
